import React from "react";
import { useNavigate } from "react-router-dom";
import BookingCalendar from "../BookingCalendar";

export default function Availability() {
  const navigate = useNavigate();

  const handleConfirm = (date, time) => {
    const params = new URLSearchParams({ date, time });
    navigate(`/quote?${params.toString()}`);
  };

  return (
    <section id="availability" className="bg-brand-stone py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal flex flex-col gap-3">
          <span className="kicker text-brand-teal">05 / Availability</span>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
              When can Max cut?
            </h2>
            <p className="max-w-md text-brand-ink/60 leading-relaxed">
              Green days are free to book. Pick a free day and a time that suits, and
              we&rsquo;ll lock it in with your quote.
            </p>
          </div>
        </div>

        <div className="reveal mt-12">
          <BookingCalendar onConfirm={handleConfirm} confirmLabel="Request this slot" />
        </div>
      </div>
    </section>
  );
}
